import { Reducer } from 'redux'
import { initialConfigState } from './initialState'
import { ChannelActionTypes, ChannelState, GENERATE_CODE } from './types'

const reducer: Reducer<ChannelState, ChannelActionTypes> = (state: ChannelState = initialConfigState, action: ChannelActionTypes) => {
	switch (action.type) {
		case GENERATE_CODE: {
			return {
				...state, ...action.payload
			}
		}
		default: {
			return state
		}
	}
}

export { reducer as channelReducer }

